import { deleteCase } from '@/backend/case'
import type { DeleteCase, DeleteCaseParams } from '@/backend/caseTypes'
import { ApiError } from '@/shared/utils/error'
import { useMutation, type UseMutationOptions } from '@tanstack/vue-query'

export const useDeleteCase = (
  options: UseMutationOptions<MutationReturn, ApiError, DeleteCaseParams, unknown> = {},
) => {
  return useMutation({
    mutationFn: async (params: DeleteCaseParams) => {
      const res = await deleteCase(params)
      if (!res.ok) {
        throw ApiError.fromFailedResult(res)
      }

      return res.data
    },
    // Retry 3 times, but stop retrying if the case is not found
    retry: (failureCount, error) => {
      if (error.status === 404) {
        return false
      }

      return failureCount < 3
    },
    ...options,
  })
}

type MutationReturn = DeleteCase['successResponse']
